import moment from 'moment'

function initApp(VM) {
    VM.filter('formatDateTime', (inputTime, formatString) => {
        // example 'YYYY-MM-DD HH:mm:ss'
        formatString = formatString || 'YYYY年MM月DD日';
        if(typeof inputTime === 'string') {
            const utcTime = moment.utc(inputTime)
            return moment(Math.floor(utcTime)).format(formatString)
        } else {
            return moment(inputTime).format(formatString)
        }
    });
}

export default initApp